import { colors } from "../../assets/colors"

export const container = {
    backgroundColor: colors.white,
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    marginTop: 50,
    padding: 20,
    paddingLeft: 50
}

export const content = {
    backgroundColor: colors.white,
    marginTop: 50
}

export const projectsListContainer = {
    marginTop: 5
}

export const projectContainer = {
    display: 'flex',
    flexDirection: 'row' as 'row',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background 0.2s',
}

export const projectContainerHover = {
    background:  '#f5f5f5', // Use uma cor leve do tema
}


export const projectContent = {
    height: 70,
    justifyContent: 'start',
    alignItems: 'center',
    display: 'flex',
    padding: 12,
    marginTop: 10,
    // width: '100%',
    minWidth: 300,
}

export const avatarContainer = {
    height: 36,
    width: 36,
    borderRadius: 100,
    marginRight: 10,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
}



export const projectTitleContent = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    marginLeft: 10,
}

export const projectTitle = {
    fontSize: 16,
    fontWeight: 500,
    color: colors.black,
}

export const projectDescription = {
    fontSize: 12,
    fontWeight: 400,
    color: colors.gray,
}

export const editIcon = {
    cursor: 'pointer',
    color: colors.gray,
    width: 20,
    height: 20
}

